import { render, staticRenderFns } from "./ChatterMainCalendar.vue?vue&type=template&id=2b555a86&scoped=true"
import script from "./ChatterMainCalendar.vue?vue&type=script&lang=js"
export * from "./ChatterMainCalendar.vue?vue&type=script&lang=js"
import style0 from "./ChatterMainCalendar.vue?vue&type=style&index=0&id=2b555a86&prod&scoped=true&lang=css"
import style1 from "./ChatterMainCalendar.vue?vue&type=style&index=1&id=2b555a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b555a86",
  null
  
)

export default component.exports